var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnityPartnership(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_582_198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0187 11.7381C23.4319 10.8544 24.375 9.28937 24.375 7.5C24.375 4.73875 22.1362 2.5 19.375 2.5C16.6137 2.5 14.375 4.73875 14.375 7.5C14.375 9.28937 15.3181 10.8544 16.7313 11.7381C15.8419 12.0738 15.035 12.5719 14.3431 13.1987C14.0687 10.6969 11.95 8.75 9.375 8.75C6.61375 8.75 4.375 10.9887 4.375 13.75C4.375 15.5394 5.31813 17.1044 6.73125 17.9881C3.895 19.0575 1.875 21.7887 1.875 25H16.875C16.875 22.3894 15.5412 20.0931 13.5187 18.75H26.875C26.875 15.5387 24.855 12.8075 22.0187 11.7381ZM19.375 12.5C20.1125 12.5 20.81 12.3363 21.44 12.05L19.375 15L17.31 12.05C17.94 12.3363 18.6375 12.5 19.375 12.5ZM9.375 18.75C10.1125 18.75 10.81 18.5863 11.44 18.3L9.375 21.25L7.31 18.3C7.94 18.5863 8.6375 18.75 9.375 18.75Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_582_198"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnityPartnership);
export default __webpack_public_path__ + "static/media/Unity Partnership.0383d38fc41f9872fdbe3b5acbc25ef6.svg";
export { ForwardRef as ReactComponent };